import { render, staticRenderFns } from "./LiteracyComponent3.vue?vue&type=template&id=65987751&scoped=true&"
import script from "./LiteracyComponent3.vue?vue&type=script&lang=js&"
export * from "./LiteracyComponent3.vue?vue&type=script&lang=js&"
import style0 from "./LiteracyComponent3.vue?vue&type=style&index=0&id=65987751&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65987751",
  null
  
)

export default component.exports